import type { ComponentProps, RefObject } from "react";
import { DatePicker, Portal } from "@ark-ui/react";
import clsx from "clsx";

type Props = ComponentProps<typeof DatePicker.Content> & {
  container?: RefObject<HTMLElement>;
  usePortal?: boolean;
};

const Wrapper = ({ className, container, usePortal = true, children, ...rest }: Props) => {
  return (
    <Portal container={container} disabled={!usePortal}>
      <DatePicker.Positioner>
        <DatePicker.Content
          className={clsx("p-4 bg-white border border-gray-300 rounded-8 shadow-xs", className)}
          {...rest}
        >
          {children}
        </DatePicker.Content>
      </DatePicker.Positioner>
    </Portal>
  );
};

export default Wrapper;
